export default "__VITE_ASSET__CFFAqldB__"